import { CommandBus } from "../commands/CommandBus";

const BARCODE_RESET_MS = 60;
const MIN_BARCODE_LENGTH = 4;

export class BarcodeScannerService {
  private bus: CommandBus;
  private buffer = "";
  private timer: number | null = null;
  private enabled = false;

  constructor(bus: CommandBus) {
    this.bus = bus;
  }

  setEnabled(enabled: boolean) {
    this.enabled = enabled;
  }

  handleKeyDown(event: KeyboardEvent) {
    if (!this.enabled) return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;

    if (event.key === "Enter") {
      if (this.buffer.length >= MIN_BARCODE_LENGTH) {
        const code = this.buffer;
        this.buffer = "";
        this.clearTimer();
        this.bus.execute("barcode.scan", { code }, { source: "barcode" });
      }
      return;
    }

    if (event.key.length === 1) {
      this.buffer += event.key;
      this.clearTimer();
      this.timer = window.setTimeout(() => {
        this.buffer = "";
      }, BARCODE_RESET_MS);
    }
  }

  private clearTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
